module.exports = __webpack_public_path__ + "static/media/contact4.93c1f9d5.png";